import ReactGA from 'react-ga4';

export function setUserId(id: string) {
  ReactGA.set({ id });
}
